export default {
  sessionState: {
    // default stub for localhost dev when xprops are not available
    // https://github.com/paypal/paypal-smart-payment-buttons/pull/97
    set(key: string, value: string) {
      window.sessionStorage.setItem(key, JSON.stringify(value))
      return Promise.resolve()
    },
    get(key: string) {
      const value = window.sessionStorage.getItem(key)
      return Promise.resolve(JSON.parse(value))
    },
  },
}
